<template>
    <el-footer class="my_footer">
      <div style="height: 277px;width: 1920px;margin: 0 auto;">
        <ul>
          <li style="">{{$t('footer.yeerGene')}}</li>
          <li  @click="guanyuClick" style="cursor:pointer;">{{$t('footer.aboutUs')}}</li>
          <li  @click="guanwClick" style="cursor:pointer;">{{$t('footer.officialWebsite')}}</li>
        </ul>
        <ul>
          <li>{{$t('footer.productsServices')}}</li>
          <li @click="ngClick('n')" style="cursor:pointer;">NGSure</li>
          <li  @click="auClick('a')" style="cursor:pointer;">Augury</li>
        </ul>
        <ul>
          <li>{{$t('footer.technicalSupport')}}</li>
          <li @click="contactClick" style="cursor:pointer;">{{$t('footer.contactUs')}}</li>
        </ul>
        <ul style=" margin-right: 190px;float: right;">
          <li><img src="../../assets/images/pin.png" style="width:294px; height: 135px;"></li>
            <li style="  height: 28px;
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255,255,255,0.7);
  line-height: 28px;
  margin: 16px 0;
  margin-top: 100px;
  float: left;">阅尔基因官方公众号</li>
            <li style="  height: 28px;
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255,255,255,0.7);
  line-height: 28px;
  margin: 16px 0;
  margin-top: 100px;
  float: right;">阅尔基因学术公众号</li>
        </ul>
      </div>
      <div  class="my_footer_path">
        <div style="width: 1920px;margin: auto;">
          <li class="my_footer_d">
            上海阅尔基因技术有限公司 沪公网安备31011002005278号 沪ICP备17045756号-2
          </li>
          <div style="margin-right: 200px">
            <li class="my_footer_f">
              Powered by WizInno
<!--              {{$t('footer.privacyPolicy')}}-->
            </li>
            <li class="my_footer_f" style="margin-right: -5px;">
<!--              {{$t('footer.supplementaryTermsConditions')}} |-->
            </li>
            <li class="my_footer_f" style="margin-right: -5px;">
<!--              {{$t('footer.law')}} |-->
            </li>
          </div>
        </div>
      </div>
    </el-footer>
</template>
<script>
  export default {
    name: 'footerNav',
    data () {
      return {
        clickBag:'',
      }
    },
    methods: {
      ngClick(data){
        this.clickBag = data;
        localStorage.removeItem("create_order_pro")
        localStorage.setItem('click_route',"/ngsure");
        localStorage.setItem('create_click_bg',"n");
        this.$router.push({path: '/ngsure'})
      },
      auClick(data){
        this.clickBag = data;
        localStorage.removeItem("create_order_pro")
        localStorage.setItem('click_route',"/augury");
        localStorage.setItem('create_click_bg',"a");
        this.$router.push({path: '/augury'})
      },
      contactClick(){
        window.open('https://nuprobe.com.cn/index/Page/index/catid/44.html','_blank')
      },
      guanyuClick(){
        window.open('https://nuprobe.com.cn/index/Page/index/catid/25.html','_blank')
      },
      guanwClick(){
        window.open('https://nuprobe.com.cn','_blank')
      },
    },
    created(){

    },
    mounted() {
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/nav/footer.vue